import React from "react";
import InteractiveMapLineSegment from "../components/interactive-map/InteractiveMapLineSegment";
import {connect} from "react-redux";
import * as InteractiveMapActions from "../actions/InteractiveMapActions";
import {Button, Grid, Icon, Input, Loader, Menu, Modal, Segment} from "semantic-ui-react";
import {opacityFromDate} from "../utils";
import RouteInfoModal from "../components/RouteInfoModal";
import * as ReactGA from "react-ga";
import firebase from 'firebase';
import StaticText from "../components/StaticText";
import RightTopText from "../components/RightTopText";
import {NavLink} from "react-router-dom";

class InteractiveMap extends React.Component {

    state = {
        activeRouteId: null,
        searchQuery: "",
        filterTypes: [],
        visibleRoutes: [],
        visibleTimelineItems: [],
        visibleTimelineGroups: [],
        searchFilterIds: [],

        periodDate: null,
        periodFullMonth: null,

        shipFilter: null,
        modalOpen: false,
    };

    handleOpen = () => {
        this.setState({ modalOpen: true });
        ReactGA.modalview("route-info");
    };
    handleClose = () => this.setState({ modalOpen: false });

    componentDidMount() {
        if (!this.props.beta) {
            this.props.fetchRoutes();
        }

        // let _this = this;
        // setTimeout(() => {
        //     _this.showLineDetails("SeaCloudII2019-05-08");
        // }, 4000);

    }

    setMapElement(el) {
        if (this.mapElement) return;
        this.mapElement = el;

        this.initMap();

    }

    initMap() {

        if (!window.google) {
            setTimeout(this.initMap.bind(this), 500);
            return;
        }

        let center = {lat: 37.0, lng: -20}; //fulscreen: lng 0, oud: -5

        this.map = new window.google.maps.Map(this.mapElement, {
            zoom: 3,
            center,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.LEFT_BOTTOM
            },
            gestureHandling: this.props.beta ? "none" : "greedy",
            disableDefaultUI: !!this.props.beta,
            mapTypeId: 'hybrid', //satellite
            backgroundColor: '#0d173c',

            // mapTypeControlOptions: {
            //     position: window.google.maps.ControlPosition.RIGHT_BOTTOM
            // },
        });
    }

    componentWillReceiveProps(newProps) {
        if (!window.google) {
            console.error("Received items, but map is not ready");
            return;
        }

        /* Search filter */
        if (newProps.searchFilterIds && newProps.searchFilterIds !== this.state.searchFilterIds) {
            console.log("Searching...");
            this.setState({searchFilterIds: newProps.searchFilterIds}, this.filterRoutes);
        }

        /* Trains */
        if (newProps.routes && newProps.routes && (!this.renderedRoutes || this.renderedRoutes.length === 0 || this.renderedRoutes.length !== newProps.routes.length)) {

            this.filterRoutes(newProps);

            if(!this.renderedRoutes)this.renderedRoutes = [];
            this.lines = {};

            let first = true;

            for (let route of newProps.routes) {

                if (this.renderedRoutes.filter(r => r.id === route.id).length > 0)continue;

                let infoWindow = new window.google.maps.InfoWindow({
                    content: '<table>' +
                    '<h3 style="margin-bottom:0;">' + route.provider + ' ' + route.name + '</h3>' +
                    '<h4 style="margin-bottom:0;margin-top:0;">' + route.from + ' - ' + route.to + '</h4>' +
                    '</table>'
                });
                let openInfoWindow = (marker, event) => {
                    let _this = this;
                    if (_this.openInfoWindow) {
                        _this.openInfoWindow.close();
                    }
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(_this.map, marker);
                    _this.openInfoWindow = infoWindow;
                };

                let lineSymbol = {
                    path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 1.5,
                };
                let line = new window.google.maps.Polyline({
                    path: window.google.maps.geometry.encoding.decodePath(route.path),
                    map: this.map,
                    geodesic: true,
                    strokeColor: InteractiveMap.lineColor(route),
                    strokeOpacity: 0.9,
                    strokeWeight: 4,
                    zIndex: 10,
                    icons: [{
                        icon: lineSymbol,
                        offset: '100%'
                    }],
                });
                line.addListener('click', (event) => {
                    this.showLineDetails(route.id);
                    // event.stop();
                    // event.cancelBubble = true;
                    // if (event.stopPropagation) {
                    //     event.stopPropagation();
                    // }
                    // if (event.preventDefault) {
                    //     event.preventDefault();
                    // } else {
                    //     event.returnValue = false;
                    // }
                    return false;
                    // openInfoWindow(line, event)
                });

                if (first && !this.state.activeRouteId && !route.hasDeparted && !route.request) {
                    this.setState({activeRouteId: route.id});
                    first = false;
                }

                this.renderedRoutes.push({
                    line: line,
                    ...route,
                });

            }
        }

        /* Check for period change */

        const {period} = newProps;
        const {periodDate, periodFullMonth} = this.state;
        if (period && (period.date !== periodDate || periodFullMonth !== periodFullMonth)) {
            this.setState({
                periodDate: period.date,
                periodFullMonth: period.fullMonth,
            }, this.updateLineStyles)
            // & scroll!
        }

    }

    static trackOpen(routeId) {
        firebase.firestore().collection("stats").doc("route-info-modal").collection("opens").add({
            createdAt: new Date(),
            routeId: routeId,
        })
    }

    showLineDetails(routeId, noscroll) {

        // this.props.setUserActivityHasStarted();
        if (routeId === null && this.lastShowLineDetailsDate && (new Date().valueOf() - this.lastShowLineDetailsDate.valueOf() < 400)) return;
        if (routeId === this.state.activeRouteId) {
            this.handleOpen();
            InteractiveMap.trackOpen(routeId);
        }

        //Get next legs
        let activeRouteLegs = [];
        let route = this.props.routes.filter(r => r.id === routeId)[0];
        if (route && route.ship) {
            activeRouteLegs = this.props.routes.filter(r => r.ship === route.ship);
        }

        this.lastShowLineDetailsDate = new Date();
        this.setState({
            activeRouteId: routeId,
            activeRouteLegs,

            // modalOpen: true, //@TODO: remove


        }, () => this.updateLineStyles(routeId));

        if (!noscroll && routeId) {
            setTimeout(() => {
                let el = document.getElementById("InteractiveMapLineSegment" + routeId);
                if(!el)return;
                document.getElementById("interactive-map-list-container").scrollTop = el.offsetTop;
            }, 100);
        }

        // this.lines[routeId].setOptions({strokeWeight: 6});
    }

    updateLineStyles(activeRouteId) {
        const {visibleRoutes, periodDate, periodFullMonth} = this.state;
        let now = periodDate;
        let fullMonth = periodFullMonth;

        let visibleRouteIds = visibleRoutes.map(route => route.id);

        if (!this.renderedRoutes) return;
        for (let route of this.renderedRoutes) {
            if (route.id === activeRouteId ||
                (!activeRouteId && visibleRouteIds.indexOf(route.id) !== -1)) {
                route.line.setOptions({
                    strokeWeight: (route.id === activeRouteId) ? 6 : (route.request ? Math.min(route.requests.length, 3) : 3),
                    strokeColor: (route.id === activeRouteId) ? "#fff" : InteractiveMap.lineColor(route),
                    zIndex: 1000 + opacityFromDate(route.departure.date, now, fullMonth, route.request) * 100,
                    strokeOpacity: (route.id === activeRouteId) ? 1 : opacityFromDate(route.departure.date, now, fullMonth, route.request)
                });
            } else {
                route.line.setOptions({
                    strokeWeight: (route.request ? Math.min(route.requests.length, 3) : 3),
                    strokeColor: InteractiveMap.lineColor(route),
                    zIndex: 100,
                });
            }
        }
    }

    search(searchQuery) {
        this.setState({searchQuery}, this.filterRoutes);
    }

    showShip(ship) {
        let shipFilter = (this.state.shipFilter === ship) ? null : ship;
        this.setState({shipFilter}, this.filterRoutes);
    }

    static lineColor(route) {

        if (route.hasDeparted) {
            return "#bbb";
        }
        if (route.request) {
            return "#c3c3c3";
        }

        // return "#33c3bd";
        return "#4eb2f7";
    }

    filterRoutes(newProps) {

        let {routes, timeline} = this.props;
        if (newProps) {
            routes = newProps.routes;
            timeline = newProps.timeline;
        }
        let {searchQuery, shipFilter, searchFilterIds} = this.state;

        searchQuery = searchQuery.toLowerCase();

        let visibleRoutes = [];
        if (routes) {
            visibleRoutes = routes;

            if (searchFilterIds && searchFilterIds.length > 0) {
                visibleRoutes = visibleRoutes.filter(route => searchFilterIds.indexOf(route.id) !== -1); // && !route.request
            }

            if (shipFilter) {
                visibleRoutes = visibleRoutes.filter(route => route.ship.id === shipFilter);
            }

        }


        let visibleTimelineItems = [];
        let visibleTimelineGroups = [];
        if (timeline.items) {
            visibleTimelineItems = timeline.items;
            visibleTimelineGroups = timeline.groups;

            if (shipFilter) {
                visibleTimelineItems = visibleTimelineItems.filter(route => route.ship.id === shipFilter);
                visibleTimelineGroups = visibleTimelineGroups.filter(route => route.id === shipFilter);
            }

        }

        this.setState({visibleRoutes, visibleTimelineItems, visibleTimelineGroups}, this.updateLineStyles);

    }

    render() {

        const {shipFilter, visibleRoutes, visibleTimelineItems, visibleTimelineGroups, periodDate, periodFullMonth} = this.state;
        const {ships, shipsById, routes, fetching} = this.props;

        const filtering = visibleRoutes.length !== routes.length;

        return <div className="interactive-map-container">

            {/*<Grid.Row>*/}
            {/*<Grid.Column width={8}>*/}
            {/*<h1>Showing all sailing routes</h1>*/}
            {/*</Grid.Column>*/}
            {/*<Grid.Column width={8}>*/}
            {/*</Grid.Column>*/}
            {/*</Grid.Row>*/}
            {!this.props.beta &&
            <div className="list-container" id="interactive-map-list-container">

                <div className="list">

                    {fetching ? <Loader active/> :
                        <Segment.Group>
                            {visibleRoutes.map(route =>
                                <InteractiveMapLineSegment
                                    route={route}
                                    ship={route.ship && shipsById[route.ship]}
                                    key={route.id}
                                    now={periodDate}
                                    fullMonth={periodFullMonth}
                                    active={this.state.activeRouteId === route.id}
                                    onClick={() => this.showLineDetails(route.id, true)}
                                />
                            )}
                        </Segment.Group>
                    }
                </div>
                {/*<div className="shadow" />*/}
            </div>
            }
            <div id="interactive-map" ref={el => this.setMapElement(el)} onClick={() => this.showLineDetails(null)}/>
            {/*<Grid.Row>*/}
            {/*<Timeline*/}
            {/*groups={visibleTimelineGroups}*/}
            {/*items={visibleTimelineItems}*/}
            {/*defaultTimeStart={moment()}*/}
            {/*defaultTimeEnd={moment().add("3", "months")}*/}
            {/*onItemClick={(id) => {*/}
            {/*this.showLineDetails(routes[id].id)*/}
            {/*}}*/}
            {/*/>*/}
            {/*</Grid.Row>*/}

            {/*<Grid.Row>*/}
            {/*<Grid.Column width={5} className="list-container-header">*/}
            {/*<Input icon='search' fluid placeholder="Search..." value={this.state.searchQuery}*/}
            {/*onChange={(e) => this.search(e.target.value)}/>*/}
            {/*</Grid.Column>*/}
            {/*<Grid.Column width={11}>*/}
            {/*{ships && ships.map(ship => <Button*/}
            {/*key={"button" + ship.id}*/}
            {/*basic={shipFilter !== ship.id}*/}
            {/*onClick={() => this.showShip(ship.id)}>*/}
            {/*{ship.name}*/}
            {/*</Button>)}*/}
            {/*</Grid.Column>*/}
            {/*</Grid.Row>*/}


            <RouteInfoModal open={this.state.modalOpen}
                            onClose={this.handleClose}
                            activeRouteId={this.state.activeRouteId}
                            activeRouteLegs={this.state.activeRouteLegs}
                            showLineDetails={(routeId) => this.showLineDetails(routeId)}
            />
        </div>
    }
}


export default connect(state => ({
    routes: state.interactiveMap.routes,
    ships: state.interactiveMap.ships,
    shipsById: state.interactiveMap.shipsById,
    timeline: state.interactiveMap.timeline,
    searchFilterIds: state.interactiveMap.searchFilterIds,
    fetching: state.interactiveMap.fetchingRoutes,
    period: state.interactiveMap.period,
}), dispatch => ({
    fetchRoutes: () => dispatch(InteractiveMapActions.fetchInteractiveMapRoutes()),
    // setUserActivityHasStarted: () => dispatch(InteractiveMapActions.setUserActivityHasStarted()),
}))(InteractiveMap)


// WEBPACK FOOTER //
// ./src/homepage/InteractiveMap.js